import { reactive } from 'vue'

export const SurveyCreationStore = reactive({
    name: "",
    places: {},
    placesInternal: {},
    surveyors: {},
});